// online.{brand} root — RequireAuth gate around three routes.
// Tracks the worker's routes/online.tsx + online/devices.tsx + online/dev-mfa.tsx
// surfaces, but the auth boundary lives behind the BFF (`/api/auth/me`) instead
// of a worker session cookie.

import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import { RequireAuth } from "./lib/auth-guard";
import { IdleLogout } from "./lib/idle-logout";
import { ensurePageStylesheet } from "./lib/modal";
import { Dashboard } from "./routes/Dashboard";
import { Devices } from "./routes/Devices";
import { DevMfa } from "./routes/DevMfa";

export function App() {
  useEffect(() => {
    ensurePageStylesheet();
  }, []);

  return (
    <BrowserRouter>
      <RequireAuth>
        {(session) => (
          <>
            <IdleLogout />
            <Routes>
              <Route path="/" element={<Dashboard session={session} />} />
              <Route path="/devices" element={<Devices session={session} />} />
              <Route path="/dev/mfa" element={<DevMfa session={session} />} />
            </Routes>
          </>
        )}
      </RequireAuth>
    </BrowserRouter>
  );
}
